// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"ccc94082","175":"54928389","239":"2f822dd7","455":"aea072d9","605":"11cdb2fa","616":"ae85808c","711":"9d56eed4","818":"ba6cd606","820":"e256fccb","952":"b787554a","977":"f9826cbd"}[chunkId] + ".chunk.js";
};